<template>
    <div style="display: flex; height: 100vh;">
      <!-- Zijpaneel -->
      <div style="width: 250px; background: #f4f4f4; padding: 1rem;">

<b-form-checkbox
  v-model="drawMode"
  switch
  class="mb-3"
>
  Tekenmodus
</b-form-checkbox>

        <h3>Buildings</h3>

        <div v-for="(building, i) in buildings" :key="i" style="margin-bottom: 12px;">
            <div class="buildings">
                <span>🏠 building_{{ i }}</span>

                <div
                    v-for="(layer, j) in building.layers"
                    :key="j"
                    v-if="layer.isClosed"
                    class="layer">
                    <label title="Hoogte aanpassen">↕️</label>
                    <input
                        class="layerheight"
                        type="number"
                        v-model.number="layer.height"
                        @keydown.enter="updateLayerHeight(i,layer)"
                        @keydown.tab="updateLayerHeight(i,layer)"
                    />
                </div>
            </div>
        </div>

      </div>
  
<div
  ref="sceneContainer"
  :class="{ 'drawing-mode': drawMode }"
  style="flex: 1;"
></div>
    </div>
  </template>
  
  <script>
  import * as THREE from 'three';
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
  
  export default {
    data() {
      return {
        drawMode: false,
        scene: null,
        camera: null,
        renderer: null,
        raycaster: new THREE.Raycaster(),
        mouse: new THREE.Vector2(),
        plane: null,
        buildings:[],
        currentBuilding:null,
        currentLayer:null,
        layerStarted: false
      };
    },
    mounted() {
        this.initScene();
        window.addEventListener('resize', this.onWindowResize);
        window.addEventListener('click', this.onClick);
    },
    methods: {
        initScene() {
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.1, 1000);
        this.camera.position.set(0, 50, 80);
        this.camera.lookAt(0, 0, 0);

        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.$refs.sceneContainer.appendChild(this.renderer.domElement);

        const light = new THREE.DirectionalLight(0xffffff, 1);
        light.position.set(10, 20, 10);
        this.scene.add(light);
        this.scene.add(new THREE.AmbientLight(0xffffff, 0.4));

        const geometry = new THREE.BoxGeometry(100, 1, 100);
        const material = new THREE.MeshStandardMaterial({ color: 0xdddddd });
        this.plane = new THREE.Mesh(geometry, material);
        this.plane.position.y = -0.5; // zodat bovenkant precies op Y=0 ligt
        this.plane.name = 'floor';
        this.scene.add(this.plane);

        const grid = new THREE.GridHelper(100, 50);
        this.scene.add(grid);

        // Voeg OrbitControls toe
        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        this.controls.target.set(0, 0, 0);
        this.controls.update();


        const animate = () => {
            requestAnimationFrame(animate);
            this.controls.update();
            this.renderer.render(this.scene, this.camera);
        };
        animate();
        },
        isSurfaceHorizontal(intersect, maxAngleDeg = 10) {
            if (!intersect.face || !intersect.object) return false;

            // Clone en transformeer de normaal naar wereldruimte
            const normal = intersect.face.normal.clone();
            intersect.object.updateMatrixWorld(true);
            const normalMatrix = new THREE.Matrix3().getNormalMatrix(intersect.object.matrixWorld);
            normal.applyMatrix3(normalMatrix).normalize();

            // Vergelijk met 'up' vector (0,1,0)
            const angle = normal.angleTo(new THREE.Vector3(0, 1, 0));
            const angleDeg = THREE.MathUtils.radToDeg(angle);

            return angleDeg <= maxAngleDeg;
        },
        onClick(event) {

            if (!this.drawMode) return;

            const rect = this.renderer.domElement.getBoundingClientRect();
            this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

            this.raycaster.setFromCamera(this.mouse, this.camera);
            
            const meshes = this.buildings
                .flatMap(b => b.layers.map(l => l.mesh))
                .filter(Boolean);

            const intersects = this.raycaster.intersectObjects([this.plane, ...meshes]);

            
            if (intersects.length > 0) {

                const intersect = intersects[0];

                //wat heb ik geraakt?
                let hitname = intersect.object.name;


                if(this.layerStarted == false){
                    if(hitname == "floor"){
                        this.addBuilding();
                    }
                    else{
                        let buildingindex = intersect.object.userData.buildingIdx;
                        console.log("building: " + buildingindex);
                        this.addLayer(buildingindex);
                    }
                    this.layerStarted = true;
                }
         

                if (!this.isSurfaceHorizontal(intersect)) {
                    console.log("Niet horizontaal genoeg");
                    return;
                }

                const point = intersect.point;

                const newPoint = { x: point.x, y: point.y, z: point.z };
                this.addSphere(newPoint.x, point.y, newPoint.z); 


                // Check of klik dicht bij eerste punt is
                if (this.currentLayer.points.length > 2) {
                    const first = this.currentLayer.points[0];
                    const dist = Math.hypot(first.x - newPoint.x, first.z - newPoint.z);

                    if (dist < 2) {
                        var buildingIdx = null;
                         if(hitname == "floor") //nieuw gebouw
                         {
                            buildingIdx = this.buildings.length -1;
                         }
                        else{
                            //we hitten een layer, daar kunnen we de gebouwdata uithalen

                            //console.log(intersect.object.userData);

                            buildingIdx = intersect.object.userData.buildingIdx;       
                        }

                        this.currentLayer.isClosed = true;
                        this.drawPoints();
                        this.createMesh(buildingIdx, this.currentLayer);

                        this.layerStarted = false;

                        return;
                    }
                }

                this.currentLayer.points.push(newPoint);
                this.drawPoints();
            }
        },
        makeLine(a, b) {
            const geo = new THREE.BufferGeometry().setFromPoints([
                new THREE.Vector3(a.x, 0.1, a.z),
                new THREE.Vector3(b.x, 0.1, b.z)
            ]);
            const mat = new THREE.LineBasicMaterial({ color: 0x0000ff });
            const line = new THREE.Line(geo, mat);
            line.name = 'helper';
            return line;
        },
        drawPoints() {

            // // Verwijder oude lijnen uit de scene
            // this.currentLayer.lines.forEach(line => {
            //     this.scene.remove(line);
            // });
            // this.currentLayer.lines = [];

            // Teken nieuwe lijnen
            for (let i = 0; i < this.currentLayer.points.length - 1; i++) {
                const a = this.currentLayer.points[i];
                const b = this.currentLayer.points[i + 1];
                const line = this.makeLine(a, b);
                this.scene.add(line);
                this.currentLayer.lines.push(line);
            }

            // Sluit de polygoon als nodig
            if (this.currentLayer.isClosed && this.currentLayer.points.length > 2) {
                const last = this.currentLayer.points[this.currentLayer.points.length - 1];
                const first = this.currentLayer.points[0];
                const line = this.makeLine(last, first);
                this.scene.add(line);
                this.currentLayer.lines.push(line);
            }
        },
        addSphere(x, y, z) {
        const geometry = new THREE.SphereGeometry(0.3, 16, 16);
        const material = new THREE.MeshStandardMaterial({ color: 0xff0000 });
        const sphere = new THREE.Mesh(geometry, material);
        sphere.position.set(x, y, z);
        this.scene.add(sphere);
        },
        addLayer(buildingIdx){

            var building = this.buildings[buildingIdx];

            building.layers.push({
                isClosed:false,
                height: 10, //standaard hoogte
                points:[],
                lines:[],
                mesh:null
            });

            this.currentLayer = building.layers.at(-1);
        },
        addBuilding(){

            let building = {
                layers: []
            };

            let layer = {
                id: 0, 
                isClosed:false,
                height: 10, //standaard hoogte
                points:[],
                lines:[],
                mesh:null
            };

            building.layers.push(layer);
            this.buildings.push(building);

            this.currentLayer = building.layers.at(-1);

        },
        updateMesh(buildingIndex, layer){

            console.log(`buildingindex:${buildingIndex}`)

            if(layer != null && layer.mesh != null){

                var oldheight = this.getHeight(layer.mesh);
                
                const schaalFactor = layer.height / oldheight;
                layer.mesh.scale.y *= schaalFactor; 

                const deltaHoogte = oldheight - layer.height;
                layer.mesh.position.y += deltaHoogte

                this.updateLayerHeights(buildingIndex, layer, deltaHoogte);
            }
        },
        createMesh(buildingIndex, layer) {
            if (!layer.isClosed || layer.points.length < 3) return;

            const height = layer.height;

            // Bereken centroid voor centreren (alleen voor visuele offset)
            const centroid = layer.points.reduce(
                (acc, p) => {
                    acc.x += p.x;
                    acc.z += p.z;
                    return acc;
                },
                { x: 0, z: 0 }
            );
            centroid.x /= layer.points.length;
            centroid.z /= layer.points.length;

            const basePoints = layer.points.map(p => new THREE.Vector3(p.x - centroid.x, p.y, p.z - centroid.z));
            const topPoints = basePoints.map(p => new THREE.Vector3(p.x, p.y + height, p.z));

            const vertices = [];
            const indices = [];
            const vertexCount = basePoints.length;

            // Voeg basis- en top-punten toe aan vertices array
            basePoints.concat(topPoints).forEach(v => {
                vertices.push(v.x, v.y, v.z);
            });

            // Zijkanten
            for (let i = 0; i < vertexCount; i++) {
                const next = (i + 1) % vertexCount;
                const a = i;
                const b = next;
                const c = i + vertexCount;
                const d = next + vertexCount;

                // Wand: twee driehoeken
                indices.push(a, b, d);
                indices.push(a, d, c);
            }

            // Basis (onderkant – clockwise winding om naar beneden te kijken)
            for (let i = 2; i < vertexCount; i++) {
                indices.push(0, i, i - 1);
            }

            // Top (tegenovergesteld winding voor naar boven gericht)
            for (let i = 2; i < vertexCount; i++) {
                indices.push(vertexCount, vertexCount + i - 1, vertexCount + i);
            }

            const geometry = new THREE.BufferGeometry();
            geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
            geometry.setIndex(indices);
            geometry.computeVertexNormals();

            //const material = new THREE.MeshStandardMaterial({ color: "#78B6DC", side: THREE.DoubleSide });

            const material = new THREE.MeshStandardMaterial({
                color: "#78B6DC",
                side: THREE.DoubleSide,
                flatShading: true
            });

            const mesh = new THREE.Mesh(geometry, material);

            mesh.name = layer.id;
            mesh.userData = {
                buildingIdx: buildingIndex
            };

            // Positioneer het geheel op de juiste locatie
            mesh.position.set(centroid.x, 0, centroid.z); // Y begint gewoon bij laagste punt

            this.scene.add(mesh);
            layer.mesh = mesh;
        },
        updateLayerHeights(buildingIndex, layer, heightadjust){

            let building  = this.buildings[buildingIndex];

            let layers = building.layers;
            
            const currentIndex = layers.findIndex(l => l === layer);

            console.log(`building${buildingIndex} layerindex: ${currentIndex}`);

            if (currentIndex >= 0) {
                for (let i = currentIndex + 1; i < layers.length; i++) {
                    //layers[i].height += heightadjust; // bijvoorbeeld 2 meter erbij
                   // this.updateMesh(buildingIndex, layers[i]);
                                   
                   layers[i].mesh.position.y -= heightadjust;
                }
            }


        },
        createMesh2(buildingIndex, layer) {

            if (!layer.isClosed || layer.points.length < 3) return;

            // Bereken centroid
            const centroid = layer.points.reduce(
                (acc, p) => {
                    acc.x += p.x;
                    acc.z += p.z;
                    return acc;
                },
                { x: 0, z: 0 }
            );
            centroid.x /= layer.points.length;
            centroid.z /= layer.points.length;

            // Let op: maak shape in XY vlak (niet XZ)
            const shape = new THREE.Shape(
                layer.points.map(p => new THREE.Vector2(p.x - centroid.x, p.z - centroid.z))
            );

            const geometry = new THREE.ExtrudeGeometry(shape, {
            depth: layer.height,
            bevelEnabled: false,
            });

            const material = new THREE.MeshStandardMaterial({ color: "#78B6DC" });
            const mesh = new THREE.Mesh(geometry, material);

          //  console.log(layer);
            mesh.name = layer.id;
            mesh.userData = {
                buildingIdx: buildingIndex
            }

            // Extrude in Z → draai daarna -90° over X, zodat Z→Y
            mesh.rotation.x = Math.PI / 2;

            //de bovenkant van de mesh is op 0, dus om te tonen omhoog plaatsen
            //mesh.position.set(centroid.x, layer.height, centroid.z);
            mesh.position.set(centroid.x, layer.points[0].y + layer.height, centroid.z);
            

            this.scene.add(mesh);
            layer.mesh = mesh;
    
        },
        updateLayerHeight(buildingIndex, layer){
            document.activeElement.blur(); // ← haalt focus van input weg
            this.updateMesh(buildingIndex, layer);
        },
        onWindowResize() {
            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();
            this.renderer.setSize(window.innerWidth, window.innerHeight);
        },
        getHeight(mesh) {
            const box = new THREE.Box3().setFromObject(mesh);
            return box.max.y - box.min.y;
        }
    },
    computed:{

    },
    watch: {
        drawMode(enabled) {
            if (this.controls) {
            this.controls.enabled = !enabled;
            }
        }
    }
}
  </script>

<style scoped>

.drawing-mode {
  cursor: crosshair;
}

.buildings {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  font-family: sans-serif;
}

.buildings > span {
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
}

.layer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
}

.layer label {
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.layerheight {
  width: 60px;
  padding: 4px 6px;
  font-size: 14px;
  border: 1px solid #aaa;
  border-radius: 4px;
}


</style>
  